/**
 * Parse markdown content into structured sections - EXACT COPY of backend parse_markdown_to_structure()
 * This ensures imported skills and builder-generated skills render identically
 */

export function parseMarkdownToSections(content) {
  if (!content || typeof content !== 'string') {
    return [];
  }

  // Remove YAML frontmatter if present
  content = content.replace(/^---\s*\n[\s\S]*?\n---\s*\n/, '');

  const sections = [];
  const lines = content.split('\n');

  let i = 0;
  while (i < lines.length) {
    const line = lines[i];

    // Detect code blocks (```)
    if (line.trim().startsWith('```')) {
      // Start of code block
      const language = line.trim().substring(3).trim() || 'text';
      const code_lines = [];
      i += 1;

      // Collect code lines until closing ```
      while (i < lines.length && !lines[i].trim().startsWith('```')) {
        code_lines.push(lines[i]);
        i += 1;
      }

      sections.push({
        type: 'code',
        language: language,
        content: code_lines.join('\n')
      });
      i += 1;
      continue;
    }

    // Detect headings (#, ##, ###, etc.)
    const headingMatch = line.match(/^(#{1,6})\s+(.+)$/);
    if (headingMatch) {
      const level = headingMatch[1].length;
      const text = headingMatch[2].trim();
      sections.push({
        type: 'heading',
        level: level,
        content: text
      });
      i += 1;
      continue;
    }

    // Detect lists (-, *, +, or numbered)
    const listMatch = line.match(/^(\s*)([-*+]|\d+\.)\s+(.+)$/);
    if (listMatch) {
      // Collect list items
      const list_items = [];

      while (i < lines.length) {
        const current_line = lines[i];
        const item_match = current_line.match(/^(\s*)([-*+]|\d+\.)\s+(.+)$/);

        if (item_match) {
          const item_indent = item_match[1].length;
          const item_text = item_match[3].trim();
          list_items.push({
            indent: item_indent,
            text: item_text
          });
          i += 1;
        } else if (current_line.trim() && !current_line.trim().startsWith('#')) {
          // Continuation of previous item
          if (list_items.length > 0) {
            list_items[list_items.length - 1].text += ' ' + current_line.trim();
          }
          i += 1;
        } else {
          break;
        }
      }

      sections.push({
        type: 'list',
        items: list_items
      });
      continue;
    }

    // Detect tables (markdown tables with |)
    if (line.includes('|') && line.trim()) {
      const table_lines = [line];
      i += 1;

      // Collect table rows
      while (i < lines.length && lines[i].includes('|')) {
        table_lines.push(lines[i]);
        i += 1;
      }

      sections.push({
        type: 'table',
        content: table_lines.join('\n')
      });
      continue;
    }

    // Regular paragraph text - preserve line breaks within paragraph
    if (line.trim()) {
      // Collect consecutive non-empty lines as paragraph
      const para_lines = [line.trim()];
      i += 1;

      while (i < lines.length && lines[i].trim() && !lines[i].trim().startsWith('#') && !lines[i].trim().startsWith('```') && !lines[i].includes('|')) {
        const next_line = lines[i].trim();
        // Check if it's not a list item
        if (!next_line.match(/^([-*+]|\d+\.)\s+/)) {
          para_lines.push(next_line);
          i += 1;
        } else {
          break;
        }
      }

      sections.push({
        type: 'paragraph',
        content: para_lines.join('\n')  // Preserve line breaks
      });
      continue;
    }

    i += 1;
  }

  return sections;
}
